import { ReactNode } from 'react';

import { Stack } from '@mui/material';
import scssVariables from '@styles/variables.module.scss';

import styles from './EndAdornmentWithStatusIcon.module.scss';
import { Icon } from '@/components/ui/Icon';

export const EndAdornmentWithStatusIcon = ({
  isValid,
  isError,
  endAdornment,
}: {
  isValid: boolean;
  isError: boolean;
  endAdornment: ReactNode;
}) => {
  if (
    !isValid &&
    !isError &&
    (endAdornment === undefined || endAdornment === null)
  ) {
    return null; // No adornment if there's no status and no custom adornment
  }

  if (isValid || isError) {
    return (
      <Stack direction="row" alignItems="center" gap={0}>
        <Icon
          className={styles.EndAdornmentStatusIcon}
          name={isValid ? 'check_small' : 'exclamation'}
          color={
            isValid ? scssVariables.ColorFog80 : scssVariables.ColorCoral60
          }
          size="medium"
          weight={400}
        />
        {endAdornment}
      </Stack>
    );
  }

  return endAdornment;
};
